import { render, staticRenderFns } from "./GoodsImgScore.vue?vue&type=template&id=dfa31f54&scoped=true"
import script from "./GoodsImgScore.vue?vue&type=script&lang=js"
export * from "./GoodsImgScore.vue?vue&type=script&lang=js"
import style0 from "./GoodsImgScore.vue?vue&type=style&index=0&id=dfa31f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa31f54",
  null
  
)

export default component.exports